import { base } from 'viem/chains'

import { useVaultApy } from '~/hooks/useTokens'
import { getAutoEarnVault, getVaultProviderName } from '~/utils/vault'

export const useAutoEarnApy = ({ enabled }: { enabled?: boolean } = {}) => {
  const vault = getAutoEarnVault()
  const { data: apy, isLoading } = useVaultApy(base.id, vault, { enabled })

  return { apy, isLoading, providerName: getVaultProviderName(vault) }
}
